import axios from "../helpers/axios";
import { messageConstants } from "./constants";

function commitNewMessage(dispatch, message, type) {
    dispatch({ type, payload: { message } });
}

export const sendTextMessage = (chatId, { sender, text }) => {
    return async (dispatch) => {
        try {
            const form = new FormData();
            form.append("sender", sender);
            form.append("text", text || "");

            const res = await axios.post(`/messages/${chatId}`, form);
            if (res.status === 201) {
                commitNewMessage(dispatch, res.data.newMsg, messageConstants.SEND_TEXT_SUCCESS);
            } else {
                dispatch({ type: messageConstants.SEND_MESSAGE_FAILURE });
            }
        } catch (e) {
            console.error("[sendTextMessage] error", e);
            dispatch({ type: messageConstants.SEND_MESSAGE_FAILURE });
        }
    };
};

export const sendFileMessage = (chatId, { sender, text }, file) => {
    return async (dispatch) => {
        try {
            const form = new FormData();
            form.append("sender", sender);
            form.append("text", text || "");
            if (file) form.append("file", file);

            const res = await axios.post(`/messages/${chatId}`, form);
            if (res.status === 201) {
                commitNewMessage(dispatch, res.data.newMsg, messageConstants.SEND_FILE_SUCCESS);
            } else {
                dispatch({ type: messageConstants.SEND_MESSAGE_FAILURE });
            }
        } catch (e) {
            console.error("[sendFileMessage] error", e);
            dispatch({ type: messageConstants.SEND_MESSAGE_FAILURE });
        }
    };
};

export const sendVoiceMessage = (chatId, { sender, durationMs }, blob) => {
    return async (dispatch) => {
        try {
            if (!blob || !blob.size) throw new Error("empty-blob");

            // имя/тип
            const fname = `voice-${Date.now()}.webm`;
            const file = new File([blob], fname, { type: "audio/webm" });
            const mediaDurationSec = Math.max(0, Math.round((Number(durationMs) || 0) / 1000));
            console.log("mediaDurationSec", mediaDurationSec);
            // формируем форму
            const form = new FormData();
            form.append("sender", sender);
            form.append("text", ""); // пусто для голосовых
            form.append("mediaDurationSec", String(mediaDurationSec));
            form.append("file", file);

            const res = await axios.post(`/messages/${chatId}`, form);
            if (res.status === 201) {
                commitNewMessage(dispatch, res.data.newMsg, messageConstants.SEND_VOICE_SUCCESS);
            } else {
                dispatch({ type: messageConstants.SEND_MESSAGE_FAILURE });
            }
        } catch (e) {
            console.error("[sendVoiceMessage] error", e);
            dispatch({ type: messageConstants.SEND_MESSAGE_FAILURE });
        }
    };
};

// export const getMessagesByChat = (chatId) => {
//     return async (dispatch) => {
//         dispatch({ type: messageConstants.GET_MESSAGES_REQUEST });
//         try {
//             const res = await axios.get(`/messages/getMessagesByChat/${chatId}`);
//             if (res.status === 200) {
//                 dispatch({
//                     type: messageConstants.GET_MESSAGES_SUCCESS,
//                     payload: { messages: res.data.messages },
//                 });
//             } else {
//                 dispatch({ type: messageConstants.GET_MESSAGES_FAILURE });
//             }
//         } catch (error) {
//             dispatch({ type: messageConstants.GET_MESSAGES_FAILURE });
//         }
//     };
// };

export const clearAdminMessages = () => ({
    type: messageConstants.CLEAR_MESSAGES,
});

export const receiveAdminMessage = (message, meId) => ({
    type: messageConstants.RECEIVE_NEW_MESSAGE,
    payload: { message, meId },
});

export const markMessagesAsRead = (chatId, userId) => {
    return async (dispatch) => {
        dispatch({ type: messageConstants.MARK_MESSAGES_AS_READ_REQUEST });
        try {
            const res = await axios.patch("/messages/mark-read", { chatId, userId });
            if (res.status === 200) {
                dispatch({
                    type: messageConstants.MARK_MESSAGES_AS_READ_SUCCESS,
                    payload: { chatId, userId },
                });
            } else {
                dispatch({ type: messageConstants.MARK_MESSAGES_AS_READ_FAILURE });
            }
        } catch {
            dispatch({ type: messageConstants.MARK_MESSAGES_AS_READ_FAILURE });
        }
    };
};

export const markMessagesAsReadSocket = (chatId, userId) => ({
    type: messageConstants.MARK_MESSAGES_AS_READ_SUCCESS,
    payload: { chatId, userId }
});

export const deleteMessage = (messageId, chatId, source = 'user') => {
    return async (dispatch) => {
        if (source === 'socket') {
            dispatch({ type: messageConstants.DELETE_MESSAGE_SUCCESS, payload: { messageId } });
            return;
        }
        dispatch({ type: messageConstants.DELETE_MESSAGE_REQUEST, payload: { messageId } });
        try {
            const res = await axios.delete(`/messages/${messageId}`);
            if (res.status === 200) {
                dispatch({ type: messageConstants.DELETE_MESSAGE_SUCCESS, payload: { messageId } });
            } else {
                dispatch({ type: messageConstants.DELETE_MESSAGE_FAILURE, payload: { messageId } });
            }
        } catch {
            dispatch({ type: messageConstants.DELETE_MESSAGE_FAILURE, payload: { messageId } });
        }
    };
};
